import { useParams } from 'react-router-dom';

export const useRequiredParams = (parameterNames: string[]): Record<string, string> => {
    const params = useParams();

    return parameterNames.reduce(
        (result, paramName) => {
            const currentParam = params[paramName];

            if (!currentParam) {
                throw new Error(`Missing required route param "${paramName}".`);
            }

            return {
                ...result,
                [paramName]: currentParam,
            };
        },
        {} as Record<string, string>,
    );
};
